import React, { useState, useEffect } from 'react'
import Layout from '../../../../brands/components/Layout/index'
import DataGrid from 'react-data-grid'
import { Icon } from '@iconify/react'
import Dropdown from 'react-bootstrap/Dropdown'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { User } from '../../../../userslisting/type'
import { useAppDispatch } from '../../../../../redux/hook'
import {
    SHOW_LOADER,
    HIDE_LOADER,
} from '../../../../../redux/slices/LoaderSlice'
import { getAllAdminUsers } from '../../../../userslisting/api'
import CustomPagination from '../../../../../components/Pagination'
import { Search } from '../../../../../components'

const ViewEmp: React.FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [users, setUsers] = useState<User[]>([])
    const [currentPage, setCurrentPage] = useState<number>(1)
    const [totalCount, setTotalCount] = useState<number>(0)
    const [userSearchKeyword, setUserSearchKeyword] = useState<string | null>(
        null
    )
    const totalPages = Math.ceil(totalCount / 10)

    const column = [
        {
            key: 'name',
            name: `${t('brand.tableColumns.name')}`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'email',
            name: `Email`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'phone',
            name: `Phone`,
            resizable: true,
            sortable: true,
        },
        {
            key: 'actions',
            name: `${t('brand.tableColumns.action')}`, // Fix the typo here
            resizable: true,
            renderCell: (props: any) => (
                <>
                    <div className="dropdown-custom-link">
                        <Dropdown>
                            <Dropdown.Toggle
                                variant="success"
                                id="dropdown-basic"
                            >
                                <Icon icon="mage:dots" />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() =>
                                        navigate(
                                            `/profile?userId=${props.row.id}`
                                        )
                                    }
                                >
                                    View Details
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </>
            ),
        },
    ]

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const fetchData = async () => {
            try {
                // Call the asynchronous function and wait for its result
                const userlisting = await getAllAdminUsers({
                    advancedSearch: {
                        keyword: userSearchKeyword,
                    },
                    isglobalSearch: false,
                    isActiveFilter: true,
                    currentPage: currentPage,
                    recordsPerPage: 10,
                })
                setUsers(userlisting?.data?.data)
                setTotalCount(userlisting?.data?.totalCount)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching holidays:', err)
            }
        }

        // Call the function to fetch data
        fetchData()
    }, [currentPage, userSearchKeyword])

    const getCurrentPage = (page: number) => {
        setCurrentPage(page)
    }

    const rows = []

    for (let i = 0; i < 7; i++) {
        rows.push({
            name: 'John',
            Email: 'john.d@yopmail.com',
            Phone: '(123) 456-7890',
        })
    }

    return (
        <div>
            <Layout>
                <div className="col-12 grid-custom-table">
                    <div className="page-information mb-3">
                        <div className="row">
                            <div className="col-sm-6">
                                <h4>Employees</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <Search
                            placeholder="Search User"
                            onSearch={(e: any) => {
                                setUserSearchKeyword(e)
                            }}
                        />
                    </div>
                    {users?.length > 0 ? (
                        <div className="table-wrapper  grid-table-timeoff mt-4">
                            <DataGrid
                                className="data-grid-table"
                                columns={column}
                                // rowKeyGetter={(row: Brand) => row.id}
                                rows={users}
                                rowHeight={60}
                                headerRowHeight={40}
                                // onCellClick={(row) => {
                                //     setSelectedBrand(row.row)
                                // }}
                                // sortColumns={sortColumns}
                                // onSortColumnsChange={setSortColumns}
                            />
                        </div>
                    ) : (
                        <div className="no-records">No records found</div>
                    )}
                    {users?.length > 0 && (
                        <div className="mt-2">
                            <CustomPagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                getPageNumber={getCurrentPage}
                            />
                        </div>
                    )}
                </div>
            </Layout>
        </div>
    )
}

export default ViewEmp
